import i18n from 'i18next';
import { useEffect, useState } from 'react';
import useShipmentStopType from '../../../redux/hooks/useShipmentStopType';
import FormSelectBox from '../Inputs/FormSelectBox';

const StopTypeSelector = ({
  placeholder = i18n.t('translation:default.fields.appointmentType.placeholder'),
  label = i18n.t('translation:default.fields.appointmentType.label'),
  rules = [],
  name,
  editMode,
  inverMode,
  singleLineMode,
  colon,
  onChange = () => {},
  hideDelivery,
  autoFocus = false,
  disableValidation = false,
  dataTestId = '',
}) => {
  const [options, setOptions] = useState([]);
  const stopTypesList = useShipmentStopType();

  useEffect(() => {
    if (stopTypesList?.length >= 0) {
      const options = stopTypesList.map((row) => ({
        label: row.text,
        value: row.value,
      }));
      setOptions(options);
    } else {
      setOptions([]);
    }
  }, [stopTypesList]);

  return (
    <FormSelectBox
      loading={stopTypesList === undefined}
      onChange={onChange}
      options={hideDelivery ? options.filter(({ value }) => value !== '2') : options}
      placeholder={placeholder}
      label={label}
      margin="mb-0"
      rules={rules}
      name={name}
      editMode={editMode}
      inverMode={inverMode}
      singleLineMode={singleLineMode}
      colon={colon}
      autoFocus={autoFocus}
      disableValidation={disableValidation}
      data-testid={dataTestId}
    />
  );
};

export default StopTypeSelector;
